module.exports = __webpack_public_path__ + "img/744.aa9f4e35.jpg";